jQuery(function() { 
    $('.package-item-pop-up-link').on('click', function (e) {
        $('#' + e.target.id + '_pop-up').css('display', 'flex');
        $('body').css('overflow', 'hidden');
    });

    $('.pop-up-close').on('click', function () {
        $('.pop-up-wrapper, .pop-up-home-wrapper').fadeOut();
        $('.cart-back-to-plan-link').attr('tabindex','7')
        $('.cart-product-remove').attr('tabindex','8')
        $('.cart-back-to-home').attr('tabindex','0')
        $('body').css('overflow', 'unset');
    });

    $(document).ready(function(){
        // GA4 custom event for login
        if(getCookie("isLoginStarted") && customerID){
            // add authToken from different layout and add it using ||
            let idToken = idTokenVal;
            idToken = parseJwt(idToken)
            
            const method = idToken["https://secure.monotype.com/user_metadata"]?.loginSource;
            // TODO find out which login method was used and pass that
            MTFAnalytics?.pushLogin({event:'login', method});
            // Deleting the isLoginStarted cookie after success
            const cookieName = 'isLoginStarted'
            const date = new Date("01-01-2000");
            expires = "; expires=" + date.toUTCString();
            document.cookie = cookieName + "=" + ("")  + expires + "; path=/";
        }
    });
    // setting cookie during login click and expiring it in 2 min
    $(document).on('click', '#header-container a.l-header-text', function(e){
        const cookieName = 'isLoginStarted'
        const date = new Date();
        date.setTime(date.getTime() + (2*60*1000));
        expires = "; expires=" + date.toUTCString();
        document.cookie = cookieName + "=" + ("true" || "")  + expires + "; path=/";

    });
    // GA event for logout
    $(document).on('click', '#header-container .profile-menu-link', function(e){
        // add authToken from different layout and add it using ||
        let idToken = idTokenVal;
        idToken = parseJwt(idToken);
        
        const method = idToken["https://secure.monotype.com/user_metadata"]?.loginSource;
        MTFAnalytics?.pushLogin({event:'logout', method});
    });
    $(document).bind('click keydown','.pop-up-wrapper',function(e){
        if(((typeof $(e.target).attr('id') !== 'undefined') && $(e.target).attr('id').indexOf('_pop-up') !== -1 && $(e.target).attr('id') !== "cart_not_allowed_pop-up" && $(e.target).attr('id') !== 'agency_different_email_login_pop-up' ) || e.key == 'Escape'){
            $('.pop-up-wrapper').fadeOut();
            $('body').css('overflow', 'unset');
        }
        if(($(e.target).attr('id') == 'expired_trial_pop-up')){
            trialExpired();
        }
        if(($(e.target).attr('id') == 'switch_company_pop-up')){
            window.history.pushState({}, document.title, "/" );
        }
    });
});
$(".pop-up-large .pop-up-content").on("scroll", function(e) {
    if ($(e.target).scrollTop() + $(e.target).innerHeight() + 2 >= $(e.target)[0].scrollHeight) {
        $("#agreeButton").prop("disabled", false);
        $(".pop-up-italic-text").fadeOut();
    }
});
if(localStorage.getItem('isIndividual') == 'true' && localStorage.getItem('currentCompany') == null){
    $('#individual_pop-up').css('display','flex')
}
